import dealerProfitDetail from './dealer_fee_bill.vue';

export default dealerProfitDetail;
